import {clustersPointLayer} from './common.js';

const layer = Object.assign({}, clustersPointLayer, {
  'id': 'vehicles-clusters-point',
  'source': 'vehicles-clusters',
})

export default layer;
